import { PropsWithChildren } from 'react';

import { cn } from 'app/utils/styles.utils';

export default function Wrapper({
  children,
  backgroundUrl,
}: PropsWithChildren<{backgroundUrl: string}>) {
  // const {connected} = useAuthentication();
  return (
    <div
      className={cn(
        'relative flex h-full w-full flex-1 flex-col items-center justify-center gap-2 bg-cover bg-fixed bg-center p-2 pb-10 pt-4 mobile:pt-5',
      )}
      style={{backgroundImage: `url(${backgroundUrl})`, overflow: 'hidden'}}>
      {/* {!connected && (
        <>
          <div
            className="absolute bottom-0 hidden h-[35%] w-full md:block"
            style={{
              background:
                'radial-gradient(ellipse at bottom center, rgba(57, 114, 183, 1) 0%, transparent 70%)',
              minHeight: '150px',
            }}
          />
          <div className="absolute bottom-0 h-[25%] w-full bg-gradient-to-t from-[#3972b7] to-transparent md:hidden" />
          <img
            src="/assets/planet-blur.png"
            className="absolute bottom-[-200px] left-14 hidden md:block md:h-[250px] md:w-[250px] lg:h-[300px] lg:w-[300px]"
          />
          <img
            src="/assets/planet-crystal.png"
            className="absolute bottom-[-75px] right-14 hidden md:bottom-[-100px] md:block md:h-[150px] md:w-[150px] lg:h-[200px] lg:w-[200px] "
          />
        </>
      )} */}
      {children}
    </div>
  );
}
